import {
  Table,
  TableBody,
  TableCell,
  TableHead,
} from '@src/common/components/Table';
import { TableRow } from '@src/common/components/TableRow';
import type { ReactNode } from 'react';

export type RowDefinition = {
  id: string;
  columnsContent: ReactNode[];
};

type Props = {
  columnsName: string[];
  rows: RowDefinition[];
  ariaLabelledBy?: string;
  size?: 'small' | 'medium';
};

export const SimpleTable = ({
  columnsName,
  rows,
  ariaLabelledBy,
  size,
}: Props) => {
  return (
    <Table aria-labelledby={ariaLabelledBy} size={size}>
      <TableHead>
        <TableRow key={`${ariaLabelledBy}-header-row`}>
          {columnsName.map((column, i) => (
            <TableCell key={`${ariaLabelledBy}-column-${i}`}>
              {column}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map(({ id, columnsContent }) => (
          <TableRow key={`row-${id}`} hover>
            {columnsContent.map((column, i) => (
              <TableCell key={`row-${id}-column-${i}`}>{column}</TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
